import { createUrl } from "../create-url";
import { TRoute, TRoutes, TThirdPartyRoutes } from "../routes.types";

export const thirdParty: TThirdPartyRoutes = {
  help: ({ config }: TRoute = {}) =>
    createUrl("https://help.katkin.com/en", config),
  fussyEatersInDepthGuide: ({ config }: TRoute = {}) =>
    createUrl("https://help.katkin.com/en/articles/429714-fussy-eaters-in-depth-guide", config),
  clubhouse: ({ config }: TRoute = {}) =>
    createUrl("https://www.facebook.com/groups/katkin.clubhouse/", config),
  contactUs: ({ config }: TRoute = {}) =>
    createUrl("https://help.katkin.com/en/articles/439320-contacting-our-customer-experience-team", config),
  reviews: ({ config }: TRoute = {}) =>
    createUrl("https://uk.trustpilot.com/review/katkin.com", config),
  careers: ({ config }: TRoute = {}) =>
    createUrl("https://katkin.jobs.personio.com/", config),
  instagram: ({ config }: TRoute = {}) =>
    createUrl("https://www.instagram.com/katkin.club/", config),
  youtube: ({ config }: TRoute = {}) =>
    createUrl("https://www.youtube.com/channel/UC54z0neHFbv6c5M3dNdBhgQ", config),
  email: ({ config }: TRoute = {}) =>
    createUrl("mailto:meow@katkin.com", config),
} as const satisfies TRoutes;
